import { PageContainerRoot } from './page-container';
import { PageContainerVariantProps } from './page-container.types';

/** Full-bleed content that spans the available width (e.g. wide tables). */
export const Fluid = (props: PageContainerVariantProps) => <PageContainerRoot {...props} />;

Fluid.displayName = 'PageContainer.Fluid';
